import { render, staticRenderFns } from "./DocomoMobaku.vue?vue&type=template&id=4e6da808&"
import script from "./DocomoMobaku.vue?vue&type=script&lang=js&"
export * from "./DocomoMobaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports